export const storage = {
  AUTH_TOKENS: 'authTokens',
  MINT_PASS_ID: 'mintPassId',
  MINT_PASS_GROUP_ID: 'mintPassGroupId',
  SELECTED_EDITION: 'selectedEdition',
  TX_HASH: 'txHash',
}
